// extracted by mini-css-extract-plugin
export var notificationHost = "_bz-0";